module.exports = __webpack_public_path__ + "img/ihar.s__600x600.2554281e.jpg";